// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Zc4K","icon":"style_icon__1PVr4","title":"style_title__1hfGA"};